import { CircularProgress, Box, Grid } from "@mui/material";
import BasicDetails from "./basic-details";
import OtherDetails from "./other-details";
import DomainDetails from "./domain-details/index";
import ProjectDetails from "./project-details";
import CustomBtnFilled from "../../atoms/form-molecules/CustomBtnFilled";
import styles from "./add-project.module.scss";
import { useHookFormContext } from "../../utils/hooks/useHookFormContext";
import { useEffect, useState } from "react";

const AddProjectFields = (props: any) => {
  const { watch } = useHookFormContext();
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (type === "change") {
        if (props.handleFormChange) {
          props.handleFormChange();
        }
      }
    });

    return () => subscription.unsubscribe();
    //eslint-disable-next-line
  }, []);

  return (
    <Box sx={{position: "relative"}}>
      <Grid container>
        <BasicDetails isLogExtension={props.isLogExtension} isEditProject={props.isEditProject} setIsLoading={setIsLoading} />
        <ProjectDetails isEditProject={props.isEditProject} />
        <DomainDetails />
        <OtherDetails />
        <Grid className={styles.actionRow} item xs={12}>
          <CustomBtnFilled
            label="cancel"
            variant="outlined"
            onClick={props.handleClose}
          />
          <CustomBtnFilled
            label={props.isLogExtension ? "Continue" : "submit"}
            variant="contained"
            buttonType="submit"
          />

        </Grid>
      </Grid>
      {isLoading && (
        <Box sx={{position: "absolute", top: 0, left: 0,zIndex: 200, width: "100%", height: "100%", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "rgba(250,250,250,0.5)"}}>
          <CircularProgress />
        </Box>
        ) 
      }
    </Box>
  );
};

export default AddProjectFields;
